import { render, staticRenderFns } from "./ColumnManage.vue?vue&type=template&id=2659f870&scoped=true&"
import script from "./ColumnManage.vue?vue&type=script&lang=js&"
export * from "./ColumnManage.vue?vue&type=script&lang=js&"
import style0 from "./ColumnManage.vue?vue&type=style&index=0&id=2659f870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2659f870",
  null
  
)

export default component.exports